import styled from 'styled-components';
// import palette from '../../../lib/styles/palette';

import React, { useState } from 'react';
import Modal from '../../common/Modal';
import { MultiOutput } from '../common/MultiInput';
import { Wrapper as MultiInput, Label, Variable, InputBlock, StyledInput, Unit } from '../common/SingleInput';
import { LoadNoLoadLabel } from '../common/LoadNoLoadLabel';
import { useSelector } from 'react-redux';

const HorizontalCurveTensionModal = ({ visible, setVisible, input, setInput }) => {
    const language = useSelector((state) => state.language);
    const isEN = language.language === 'EN' ? true : false;
    const isJP = language.language === 'JP' ? true : false;

    /* state에서 tension 정보 가져오기 */
    const drives = useSelector((state) => state.conveyorWrite.body.drives);
    const tightTensionLoad = Math.max(...drives.map((drive) => drive.tightSideTension.load));
    const tightTensionNoLoad = Math.max(...drives.map((drive) => drive.tightSideTension.noLoad));
    const slackTensionLoad = Math.min(...drives.map((drive) => drive.slackSideTension.load));
    const slackTensionNoLoad = Math.min(...drives.map((drive) => drive.slackSideTension.noLoad));

    const [carryLoad, setCarryLoad] = useState(input.carryTensionAtCurveLoad || 0);
    const [carryNoLoad, setCarryNoLoad] = useState(input.carryTensionAtCurveNoLoad || 0);
    const [returnLoad, setReturnLoad] = useState(input.returnTensionAtCurveLoad || 0);
    const [returnNoLoad, setRetrunNoLoad] = useState(input.returnTensionAtCurveNoLoad || 0);

    const onConfirm = () => {
        setInput((prev) => ({
            ...prev,
            carryTensionAtCurveLoad: carryLoad,
            carryTensionAtCurveNoLoad: carryNoLoad,
            returnTensionAtCurveLoad: returnLoad,
            returnTensionAtCurveNoLoad: returnNoLoad,
        }));
        setVisible(false);
    };

    const onCancel = () => {
        setVisible(false);
    };

    return (
        <Modal
            visible={visible}
            title={isEN ? "Input Average Tension @Horizontal Curve" : isJP ? "水平カーブ部平均張力入力" : "수평커브부 평균장력 입력"}
            description="수평 커브에 의한 저항을 계산한다."
            onCancel={onCancel}
            onConfirm={onConfirm}
            confirmText={isEN ? "Confirm" : isJP ? "確認" : "확인"}
            cancelText={isEN ? "Cancel" : isJP ? "キャンセル" : "취소"}
        >
            {/* 참고정보(긴장측, 이완측 장력) 섹션 */}
            <LoadNoLoadLabel />
            <MultiOutput
                label="Tight Side Tension"
                variable="F1"
                unit="N"
                values={[tightTensionLoad, tightTensionNoLoad]}
            />
            <MultiOutput
                label="Slack Side Tension"
                variable="F2"
                unit="N"
                values={[slackTensionLoad, slackTensionNoLoad]}
            />
            <Spacer />
            {/* 입력 섹션 */}
            <MultiInput>
                <Label>{
                            isEN
                                ? 'Average Tension @Horizontal Curve(Carrier Side)'
                                : isJP
                                ? '水平カーブ部平均張力(キャリヤ側)'
                                : '수평 커브부 평균장력(캐리어측)'
                        }</Label>
                <Variable>{}</Variable>
                <InputBlock>
                    <StyledInput
                        name="carryTensionAtCurveLoad"
                        value={carryLoad}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
                            if (newValue === '' || Number(newValue) >= 0) {
                                setCarryLoad(newValue);
                            }
                        }}
                    />
                    <StyledInput
                        name="carryTensionAtCurveNoLoad"
                        value={carryNoLoad}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
                            if (newValue === '' || Number(newValue) >= 0) {
                                setCarryNoLoad(newValue);
                            }
                        }}
                    />
                </InputBlock>
                <Unit>N</Unit>
            </MultiInput>
            <MultiInput>
                <Label>{
                            isEN
                                ? 'Average Tension @Horizontal Curve(Return Side)'
                                : isJP
                                ? '水平カーブ部平均張力(リタン側, No Load)'
                                : '수평 커브부 평균장력(리턴측, No Load)'
                        }</Label>
                <Variable>{}</Variable>
                <InputBlock>
                    <StyledInput
                        name="returnTensionAtCurveLoad"
                        value={returnLoad}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
                            if (newValue === '' || Number(newValue) >= 0) {
                                setReturnLoad(newValue);
                            }
                        }}
                    />
                    <StyledInput
                        name="returnTensionAtCurveNoLoad"
                        value={returnNoLoad}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
                            if (newValue === '' || Number(newValue) >= 0) {
                                setRetrunNoLoad(newValue);
                            }
                        }}
                    />
                </InputBlock>
                <Unit>N</Unit>
            </MultiInput>
            {/* Resistance 계산 섹션 */}
        </Modal>
    );
};

export default HorizontalCurveTensionModal;

const Spacer = styled.div`
    margin: 2rem 0;
`;

